import { render } from "./cpt-combination-page.vue?vue&type=template&id=192a71f6"
import script from "./cpt-combination-page.vue?vue&type=script&lang=js"
export * from "./cpt-combination-page.vue?vue&type=script&lang=js"

import "./cpt-combination-page.vue?vue&type=style&index=0&id=192a71f6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__